import React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

// Custom.
import { DashboardProps } from "./global";
import { useStyles } from "./styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

// const getWidgets = {};

const Dashboard: React.FC<DashboardProps> = (props) => {
  // const { className } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography component="h2" variant="h3" sx={{ textAlign: "center" }}>
        {I18n.get.messages.adminDashboard01}
      </Typography>
      <Typography
        color="primary.main"
        component="h1"
        variant="h2"
        sx={{ textAlign: "center" }}
      >
        {process.env.REACT_APP_NAME}
      </Typography>
      <Typography
        component="h3"
        variant="h6"
        sx={(theme) => ({
          marginTop: theme.spacing(5),
          textAlign: "center",
        })}
      >
        {I18n.get.messages.adminDashboard02}
      </Typography>
      <Typography
        component="h4"
        variant="body1"
        sx={(theme) => ({
          marginTop: theme.spacing(5),
          textAlign: "center",
        })}
      >
        {I18n.get.messages.adminDashboard03}
      </Typography>
      <Link href="mailto:info@vo-college.se">info@vo-college.se</Link>
    </div>
  );
};

export default Dashboard;
